export default function GlowCanvasLogo() {
  return (
    <h1 className="text-4xl font-bold inline-flex items-baseline">
      {/* Glow - Blue with VERY strong glow */}
      <span 
        className="text-blue-500"
        style={{
          textShadow: `
            0 0 10px rgba(59, 130, 246, 1),
            0 0 20px rgba(59, 130, 246, 0.8),
            0 0 30px rgba(59, 130, 246, 0.6),
            0 0 40px rgba(59, 130, 246, 0.4),
            0 0 50px rgba(59, 130, 246, 0.3)
          `
        }}
      >
        Glow
      </span>
      
      {/* Canvas - Each letter in different rainbow color with strong glow */}
      <span className="inline-flex">
        <span 
          className="text-red-500"
          style={{
            textShadow: `
              0 0 10px rgba(239, 68, 68, 1),
              0 0 20px rgba(239, 68, 68, 0.8),
              0 0 30px rgba(239, 68, 68, 0.6)
            `
          }}
        >
          C
        </span>
        <span 
          className="text-orange-500"
          style={{
            textShadow: `
              0 0 10px rgba(249, 115, 22, 1),
              0 0 20px rgba(249, 115, 22, 0.8),
              0 0 30px rgba(249, 115, 22, 0.6)
            `
          }}
        >
          a
        </span>
        <span 
          className="text-yellow-500"
          style={{
            textShadow: `
              0 0 10px rgba(234, 179, 8, 1),
              0 0 20px rgba(234, 179, 8, 0.8),
              0 0 30px rgba(234, 179, 8, 0.6)
            `
          }}
        >
          n
        </span>
        <span 
          className="text-green-500"
          style={{
            textShadow: `
              0 0 10px rgba(34, 197, 94, 1),
              0 0 20px rgba(34, 197, 94, 0.8),
              0 0 30px rgba(34, 197, 94, 0.6)
            `
          }}
        >
          v
        </span>
        <span 
          className="text-blue-500"
          style={{
            textShadow: `
              0 0 10px rgba(59, 130, 246, 1),
              0 0 20px rgba(59, 130, 246, 0.8),
              0 0 30px rgba(59, 130, 246, 0.6)
            `
          }}
        >
          a
        </span>
        <span 
          className="text-purple-500"
          style={{
            textShadow: `
              0 0 10px rgba(168, 85, 247, 1),
              0 0 20px rgba(168, 85, 247, 0.8),
              0 0 30px rgba(168, 85, 247, 0.6)
            `
          }}
        >
          s
        </span>
      </span>
      
      {/* .io - Red with VERY strong glow */}
      <span 
        className="text-red-500"
        style={{
          textShadow: `
            0 0 10px rgba(239, 68, 68, 1),
            0 0 20px rgba(239, 68, 68, 0.8),
            0 0 30px rgba(239, 68, 68, 0.6),
            0 0 40px rgba(239, 68, 68, 0.4),
            0 0 50px rgba(239, 68, 68, 0.3)
          `
        }}
      >
        .io
      </span>
    </h1>
  );
}
